// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-items[data-v-4da1cdc7]{height:100%}.image[data-v-4da1cdc7]{height:100%;position:relative}.image[data-v-4da1cdc7],.image__links[data-v-4da1cdc7]{display:flex;flex-direction:column}.image__links[data-v-4da1cdc7]{position:absolute;top:0;left:0;z-index:50}", ""]);
// Exports
module.exports = exports;
